module.exports = __webpack_public_path__ + "img/img_sec5_01.a9b0407a.jpg";